import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../services';

@Component({
  selector: 'hypenation-tickets-terms-and-conditions',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.css',
})
export class TermsAndConditionsComponent implements OnInit {

  constructor(
    private readonly _apiService: ApiService,
  ) {}
  ngOnInit(): void {
    this.scrollToTop();
  }

  public scrollToTop() : void{
    this._apiService.scrollToTop();
  }
}
